/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ResourceProviderSummary { 
    /**
     * Assigned
     */
    assigned?: number;
    /**
     * Onboarded
     */
    onboarded?: number;
    /**
     * Ready
     */
    ready?: number;
    /**
     * Assigned
     */
    tombstoned?: number;
    /**
     * Total
     */
    total?: number;
}

